/**
 * Copyright © Veeam Software Group GmbH.
 */

import { EJobStatusInteg } from '@veeam-vspc/models/web-controllers';

export type EJobStatuses = EJobStatusInteg;
export const EJobStatuses = EJobStatusInteg;
